exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supply-shortage[data-v-33b6d678] {\n  border: 1px solid #8d29a0;\n  border-radius: 1px;\n  padding: 11px 20px;\n  max-width: 620px;\n  margin-bottom: 30px;\n}\n@media (min-width: 991px) {\n.supply-shortage[data-v-33b6d678] {\n    margin-left: 13.733333%;\n    padding: 10px 15px;\n}\n}\n.supply-shortage__text[data-v-33b6d678] {\n  color: #5f707f;\n  line-height: 21px;\n  margin: 0;\n}\n.supply-shortage__text--cancel-order[data-v-33b6d678] {\n  margin-top: 15px;\n}\n.supply-shortage span[data-v-33b6d678] {\n  color: #8d29a0;\n  font-weight: bold;\n}", ""]);

// exports
